import { Controller } from "stimulus"

export default class extends Controller {
  open(event) {
    // Store the candidate ID from the clicked link
    const candidateId = event.currentTarget.dataset.candidateId;
    document.getElementById('cancellationModal').dataset.candidateId = candidateId;
    document.getElementById('cancellationModal').classList.add('is-active');
  }

  close(){
    document.getElementById('cancellationModal').classList.remove('is-active');
    // Clear the textarea
    document.getElementById('cancellationReasonText').value = '';
  }

  send(event) {
    event.preventDefault();
   
    let reason = document.getElementById('cancellationReasonText').value;
   
    if (!reason) {
      alert("La raison de l'annulation est obligatoire.");
      return;
    }
   
    let candidateId = document.getElementById('cancellationModal').dataset.candidateId;
    let url = `/secretary_candidates/${candidateId}/cancel_rejection`;
    let params = new URLSearchParams({ cancellation_reason: reason });
    
    // Send as GET request with params
    fetch(`${url}?${params.toString()}`, {
      method: 'GET',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.close();
        window.location.reload();
      } else {
        alert(data.message || "Une erreur s'est produite.");
      }
    })
    .catch(error => {
      alert("Une erreur s'est produite lors de l'annulation.");
    });
  }
}

